import styled from "styled-components";

export const TimelineWrapper = styled.div`
  width: 100%;
  padding: 16px;
  background: transparent;
  border-radius: 8px;
  position: relative;
`;

export const TimelineTitle = styled.div`
  color: #767676;
  font-size: 12px;
  font-family: Readex Pro;
  font-weight: 300;
  line-height: 15.6px;
  margin-bottom: 16px;
`;

export const TimelineContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const TimelineVerticalLine = styled.div`
  position: absolute;
  left: 6px;
  top: 20px;
  bottom: 5px;
  width: 2px;
  background: #d1d1d1;
`;

export const TimelineNodeRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 5px;
  position: relative;
`;

export const TimelineHexagonNode = styled.div`
  width: 18px;
  height: 20px;
  background: transparent;
  flex-shrink: 0;
  position: relative;
  left: -2px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TimelineText = styled.div``;

export const TimelineNodeLabel = styled.span`
  color: #172a3f;
  font-size: 10px;
  font-family: Readex Pro;
  font-weight: 500;
  line-height: 12px;
  width: 120px;
  flex-shrink: 0;
  margin-top: 4px; /* Align with center of hexagon (20px height / 2 - 6px for line-height) */
`;

export const TimelineActionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  margin-top: 10px;
`;

export const TimelineActionItem = styled.span`
  color: #3f7f7d;
  font-size: 14px;
  font-family: Readex Pro;
  font-weight: 300;
  line-height: 19.6px;

  margin-left: 4ch;
  margin-bottom: 2ch;

  /* For nested divs (additional actions), add left margin */
  div {
    margin-left: 0;
  }
`;

export const TimelineEmptyState = styled.div`
  color: #aaa;
  text-align: center;
  padding: 20px;
`;
